/**
 * Page with start rating and thank you at the end
 * 
 */

import React, { useEffect } from "react";
import { Trans } from "react-i18next";


function FinishedPageNotRefugee() {
  useEffect(() => {
    return function cleanup() {
    };
  });

  return (
    <div>

      <div className="app-page finished">
        <br />
        <br />
        <br />
        <div>
          <h1 className="mb-8 text-center">&nbsp;</h1>
          <div className="text-center text-white">
            <Trans>We are sorry, but currently the project works for those who are located in Ukraine. </Trans>
          </div>
        </div>
        <br />

        <div className="app-fragment pull-bottom-fixed">
          <div className="content-text">
            &nbsp;
          </div>
          
        </div>

      </div>
    </div>
  );
}

export default FinishedPageNotRefugee;